export default {"src":"/_next/static/media/MinimallyInvasiveTechnique.9fc7226d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};